import {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
} from '@/utils/aMap'

const setDeafultLocal = ({ commit, state }) => {
  state.locationInfo.lat = 23.12463
  state.locationInfo.lng = 113.36199
  state.locationInfo.city = '广州市'
  state.locationInfo.province = '广东省'

}

// 获取定位信息
const getLocation = ({commit, state}) => {
  return new Promise(async (resolve, reject) => {
    // console.log()
    // const AmaplocalCity = await LocalCity()
    // // console.log(AmaplocalCity.getLocalCity)
    
    // AmaplocalCity.getLocalCity((status, result) => {
    //   console.log(status, result)
    // })
    const AMapLocation = await location().catch((err) => {
      console.error(err, '初始化定位失败')
    })
    // const issup = AMapLocation.isSupported
  
    await AMapLocation.getCurrentPosition(
      async (status, result) => {
        console.log(status, result, 'getCurrentPosition')
        if (status === 'complete') {
          state.locationInfo.lng = result.position.lng
          state.locationInfo.lat = result.position.lat
          // const cityResult = await getCityconvertFrom({
          //   lat: result.position.lat,
          //   lng: result.position.lng
          // })
          const AMapSearchCity = await SearchCity().catch(err => {
            console.error(err, '初始化获取城市失败')
          })
            console.log(status, result, 'AMapSearchCity')
          const lnglat = [
            result.position.lng,
            result.position.lat
          ]
          
          await AMapSearchCity.getAddress(
            lnglat,
            (addressStatus, addressResult) => {
              console.log(addressStatus, addressResult, 'getAddress')
              if (
                addressStatus === 'complete' &&
                addressResult.info === 'OK'
              ) {
                state.locationInfo.city =
                  addressResult.regeocode.addressComponent.city
                state.locationInfo.province =
                  addressResult.regeocode.addressComponent.province
                  resolve({
                    status: true,
                    data: {
                      ...addressResult
                    },
                    message: '获取定位成功'
                  })
              } else {
                reject(
                  `状态: ${addressStatus} \n 结果:${addressResult} \n 获取城市失败` 
                )
                console.error(
                  `状态: ${addressStatus} \n 结果:${addressResult}`,
                  '获取城市失败'
                )
              }
            }
          )
        } else {
          await AMapLocation.getCityInfo((status, result) => {
            if (status === 'complete') {
              state.locationInfo.lat = result.position[1]
              state.locationInfo.lng = result.position[0]

              state.locationInfo.city = result.city
              state.locationInfo.province = result.province
              resolve({
                status: true,
                data: {
                  ...result
                },
                 message: '获取定位成功'
              })
            } else {
              console.error(
                `状态: ${status} \n 结果:${result}`,
                '定位失败'
              )

              // 设置一个默认地址
              setDeafultLocal({ commit, state })

              // 写一个默认地址
              reject(
                `状态: ${status} \n 结果:${result} '定位失败'`
              )
            }
          })
        }
      }
    )
  })
}

const setCity = ({ commit, state }, cityName) => {
  return new Promise(async (resolve, reject) => {
  const AMapSearchCity = await SearchCity(cityName)
  
  AMapSearchCity.getLocation(cityName, function(
    status,
    result
      ) {
          if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
            const res = result.geocodes[0]
            state.locationInfo.lng = res.location.lng
            state.locationInfo.lat = res.location.lat
            state.locationInfo.city = res.addressComponent.city
            state.locationInfo.province = res.addressComponent.province
            resolve({
              status: true
            })
          }else {
            console.error(
              `状态: ${status} \n 结果:${result}`,
              '定位失败'
            )

            resolve({
              status: false,
            })
          }
      })
   })
  // AMapSearchCity.CitySearchCallback(
  //   ({ ip: '北京' }, result) => {
  //   }
  // )
}

const state = {
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: ''
  }
}

const mutations = {}

const actions = {
  getLocation,
  setCity
  // async getLocation({ commit, state }) {

  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}